import { SVGProps, Ref, forwardRef } from 'react';

export const GripSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="m9.515 14.23 4.714-4.715-.848-.848-4.715 4.714z" fill="currentColor" />
            <path d="m12.566 14.667 2.1-2.1-.848-.85-2.1 2.101z" fill="currentColor" />
        </g>
    </svg>
));
GripSize16Glyph.displayName = 'GripSize16Glyph';
